import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import Header from "../../../../Componets/Header";
import formsData from "../../../../Data/Forms/Accounting/ClosingBalances/forms";
import headersData from "../../../../Data/Forms/Accounting/ClosingBalances/headers";
import {
  create_closing_balance,
  get_closing_balance_by_period,
  get_closing_balance,
} from "../../../../Controllers/Accounting/ClosingBalances";
import toast from "react-hot-toast";
import Loadercomponent from "../../../../Componets/Loader";

const ClosingBalanceForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(formsData);
  const [header, setHeader] = useState(headersData);
  const [branchesList, setBranchesList] = useState([]);

  const calculateClosingBalance = (debit, credit, openingBalance) => {
    return (openingBalance || 0) + (debit || 0) - (credit || 0);
  };

  const handleValueChange = (sectionIndex, optionIndex, value) => {
    const updatedValues = [...values];
    const fieldName =
      updatedValues[sectionIndex].options[optionIndex].form.name;

    updatedValues[sectionIndex].options[optionIndex].form.value = value;

    if (
      fieldName === "total_debit" ||
      fieldName === "total_credit" ||
      fieldName === "opening_balance"
    ) {
      const openingBalance = updatedValues[1].options[0].form.value;
      const totalDebit = updatedValues[1].options[1].form.value;
      const totalCredit = updatedValues[1].options[2].form.value;
      const closingBalance = calculateClosingBalance(
        parseFloat(totalDebit) || 0,
        parseFloat(totalCredit) || 0,
        parseFloat(openingBalance) || 0,
      );
      updatedValues[1].options[3].form.value = closingBalance;
    }

    if (
      (fieldName === "period_start" || fieldName === "period_end") &&
      updatedValues[0].options[0].form.value &&
      updatedValues[0].options[1].form.value &&
      updatedValues[0].options[2].form.value
    ) {
      fetchPreviousBalance(
        updatedValues[0].options[0].form.value,
        updatedValues[0].options[1].form.value,
        updatedValues[0].options[2].form.value,
      );
    }

    setValues(updatedValues);
  };

  const fetchPreviousBalance = async (branchId, startDate, endDate) => {
    try {
      const response = await get_closing_balance_by_period({
        branch_id: branchId,
        period_start: startDate,
        period_end: endDate,
      });

      if (response?.status && response?.data) {
        const updatedValues = [...values];
        updatedValues[1].options[0].form.value =
          response.data.opening_balance || 0;
        updatedValues[1].options[1].form.value = response.data.total_debit || 0;
        updatedValues[1].options[2].form.value =
          response.data.total_credit || 0;
        updatedValues[1].options[3].form.value =
          response.data.closing_balance || 0;
        updatedValues[2].options[0].form.value =
          response.data.is_locked || false;
        setValues(updatedValues);

        if (response.data.is_locked) {
          toast("This period is locked and cannot be modified", { icon: "🔒" });
        }
      }
    } catch (error) {
      console.error("Error fetching previous balance:", error);
    }
  };

  const formdata = async (data) => {
    if (data?.status) {
      setButtonLoader(true);

      const closingBalance = {
        ...data?.data,
        closing_balance: parseFloat(data?.data?.closing_balance) || 0,
        total_debit: parseFloat(data?.data?.total_debit) || 0,
        total_credit: parseFloat(data?.data?.total_credit) || 0,
      };

      const response = await create_closing_balance(closingBalance);

      if (response?.status) {
        navigate(-1);
        toast.success(response?.message);
        setButtonLoader(false);
      } else {
        setButtonLoader(false);
        if (response?.status_code === 403) {
          window.location.href = "/unauthorized";
        } else {
          toast.error(response?.message);
        }
      }
    }
  };

  const handleData = (invoice) => {
    let branch_id = invoice?.branch?._id ? invoice?.branch?._id : null;
     let branch_name = invoice?.branch?._id
      ? [
        {
          value: invoice?.branch?._id,
          label: invoice?.branch?.name,
        },
      ]
      : null;
    let period_start = invoice?.period_start ? invoice?.period_start : "";
    let period_end = invoice?.period_end ? invoice?.period_end : "";
    let opening_balance = invoice?.opening_balance
      ? invoice?.opening_balance
      : "";
    let total_debit = invoice?.total_debit ? invoice?.total_debit : "";
    let total_credit = invoice?.total_credit ? invoice?.total_credit : "";
    let closing_balance = invoice?.closing_balance
      ? invoice?.closing_balance
      : "";
    let status = invoice?.status ? invoice?.status : 0;

    values[0].options[0].form.value = branch_id;
    values[0].options[0].form.options = branch_name;
    values[0].options[1].form.value = period_start;
    values[0].options[2].form.value = period_end;

    values[1].options[0].form.value = opening_balance;
    values[1].options[1].form.value = total_debit;
    values[1].options[2].form.value = total_credit;
    values[1].options[3].form.value = closing_balance;

    values[2].options[0].form.value = status;

    console.log("idsahkn", values)
    setLoader(false);
    setValues([...values]);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);

      const data = {
        id: id,
      };

      const closing_balance = await get_closing_balance(id);

      if (closing_balance?.status) {
        handleData(closing_balance?.data);
      } else {
        toast?.error(closing_balance?.message);
      }
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    const branchId = values[0]?.options[0]?.form?.value;
    const startDate = values[0]?.options[1]?.form?.value;
    const endDate = values[0]?.options[2]?.form?.value;

    if (branchId && startDate && endDate) {
      fetchPreviousBalance(branchId, startDate, endDate);
    }
  }, [
    values[0]?.options[0]?.form?.value,
    values[0]?.options[1]?.form?.value,
    values[0]?.options[2]?.form?.value,
  ]);

  useEffect(() => {
    const openingBalance = parseFloat(values[1]?.options[0]?.form?.value) || 0;

    const totalDebit = parseFloat(values[1]?.options[1]?.form?.value) || 0;

    const totalCredit = parseFloat(values[1]?.options[2]?.form?.value) || 0;

    const closingBalance = openingBalance + totalDebit - totalCredit;

    setValues((prev) => {
      const updated = [...prev];
      updated[1].options[3].form.value = closingBalance;
      return updated;
    });
  }, [
    values[1]?.options[0]?.form?.value,
    values[1]?.options[1]?.form?.value,
    values[1]?.options[2]?.form?.value,
  ]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setValues}
          formdata={formdata}
          buttonLoader={buttonLoader}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ClosingBalanceForm;
